var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import View from "@core/views";
import Toast from "@core/components/Toast";
var RackDetailView = /** @class */ (function (_super) {
    __extends(RackDetailView, _super);
    function RackDetailView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get Rack transactions and populate tab.
     */
    RackDetailView.prototype.getRackTransactions = function (rackId) {
        var data = { object_id: rackId, object_type: 'rack' };
        this.app.api.private('get_object_transactions', {
            data: data
        }).then(function (response) {
            var transactionTab = document.getElementById('transaction-tab');
            transactionTab.innerHTML = '';
            if (response.transactions.length == 0) {
                var html = '<div class="has-text-centered has-text-muted">No transactions</div>';
                transactionTab.innerHTML += html;
            }
            for (var i = 0; i < response.transactions.length; i++) {
                var html = "\n                    <article class=\"media tc-transaction tc-{{type}}\">\n                        <figure class=\"media-left\">\n                            <div class=\"tc-transaction-icon\">\n                               <i class=\"{{icon_class}}\"></i>\n                            </div>\n                        </figure>\n                        <div class=\"media-content\">\n                            <div class=\"content\">\n                                <strong>{{display_name}}</strong>\n                                &nbsp;<time class=\"is-pulled-right\" datetime=\"{{action_time}}\" >{{action_time_natural}}</time>\n                                <br />\n                                <section class=\"tc-transaction-details\">\n                                    {{details}}\n                                </section>\n                            </div>\n                        </div>\n                    </article>\n                ";
                html = html.replace('{{type}}', response.transactions[i].type)
                    .replace('{{icon_class}}', response.transactions[i].icon_class)
                    .replace('{{display_name}}', response.transactions[i].display_name)
                    .replace('{{action_time}}', response.transactions[i].action_time)
                    .replace('{{action_time_natural}}', response.transactions[i].action_time_natural)
                    .replace('{{details}}', response.transactions[i].details);
                transactionTab.innerHTML += html;
            }
        }, function (error) {
            if (error.serverError) {
                Toast.error(error.serverError.error);
            }
            else {
                Toast.error(django.gettext('Unable to load Bin transactions'));
            }
        });
    };
    return RackDetailView;
}(View));
export default RackDetailView;
